import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const importApi = createApi({
  reducerPath: 'importApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/imports' }),
  endpoints: (builder) => ({
    sendFile: builder.mutation({
      query: ({ type, body }) => ({
        url: `/${type}`,
        method: 'POST',
        body
      })
    }),
    sendAttachmentFile: builder.mutation({
      query: ({ type, body }) => ({
        url: `/${type}_attachments`,
        method: 'POST',
        body
      })
    })
  })
})

const {
  useSendFileMutation,
  useSendAttachmentFileMutation
} = importApi

export {
  importApi,
  useSendFileMutation,
  useSendAttachmentFileMutation
}
